import moduleDescriptions from 'root/src/shared/descriptions/modules'
import { generalApiModuleDescriptionLenses } from 'root/src/client/logic/api/lenses'

const { viewOnEnterThunk } = generalApiModuleDescriptionLenses

export default (state, { moduleId }) => viewOnEnterThunk(moduleId, moduleDescriptions)
